import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { useLang } from "../../contexts/LangContext";
import { t } from "../../i18n/translations";
import { Users, ChevronRight } from "lucide-react";

export default function AdminCustomers() {
  const { lang } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/customers").then((r) => setItems(r.data || [])); }, []);

  return (
    <div className="p-5 sm:p-8 lg:p-10" data-testid="admin-customers-page">
      <h1 className="font-display text-3xl sm:text-4xl text-ink flex items-center gap-3"><Users className="w-6 h-6 sm:w-7 sm:h-7 text-terracotta" strokeWidth={1.5} /> {t(lang, "admin.customers")}</h1>
      <p className="text-sm text-ink-muted mt-2">Klicke auf eine Kundin, um Details, Notizen und die Buchungs-Historie zu sehen.</p>

      {/* Mobile cards */}
      <div className="mt-6 space-y-3 md:hidden">
        {items.map((c) => (
          <Link to={`/admin/customers/${c.id}`} key={c.id} className="block bg-white border border-border rounded-md p-4 hover:border-terracotta transition-colors" data-testid={`customer-card-${c.id}`}>
            <div className="flex items-center justify-between">
              <div className="font-display text-lg text-ink">{c.name}</div>
              <div className="flex items-center gap-2">
                <span className="text-xs bg-terracotta/10 text-terracotta px-2 py-1 rounded-full">{c.bookings_count || 0}×</span>
                <ChevronRight className="w-4 h-4 text-ink-muted" strokeWidth={1.5} />
              </div>
            </div>
            <div className="block mt-1 text-xs text-terracotta break-all">{c.email}</div>
            {c.phone && <div className="text-xs text-ink-muted">{c.phone}</div>}
            {c.birthdate && <div className="text-xs text-ink-muted mt-1">🎂 {c.birthdate}</div>}
          </Link>
        ))}
        {items.length === 0 && <div className="text-center py-10 text-ink-muted">—</div>}
      </div>

      {/* Desktop table */}
      <div className="hidden md:block mt-8 bg-white border border-border rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/60 text-xs uppercase tracking-wider text-ink-muted">
            <tr>
              <th className="text-left px-5 py-3">{t(lang, "admin.customer")}</th>
              <th className="text-left px-5 py-3">{t(lang, "admin.email")}</th>
              <th className="text-left px-5 py-3">{t(lang, "contact.phone")}</th>
              <th className="text-left px-5 py-3">Geburtstag</th>
              <th className="text-left px-5 py-3">{t(lang, "admin.bookings")}</th>
              <th className="text-right px-5 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} className="border-t border-border hover:bg-sand-soft cursor-pointer" data-testid={`customer-row-${c.id}`} onClick={() => { window.location.href = `/admin/customers/${c.id}`; }}>
                <td className="px-5 py-4 text-ink font-medium">
                  <Link to={`/admin/customers/${c.id}`} className="hover:text-terracotta" data-testid={`customer-link-${c.id}`}>{c.name}</Link>
                </td>
                <td className="px-5 py-4 text-ink-muted">{c.email}</td>
                <td className="px-5 py-4 text-ink-muted">{c.phone}</td>
                <td className="px-5 py-4 text-ink-muted text-xs">{c.birthdate || "—"}</td>
                <td className="px-5 py-4 text-ink-muted">{c.bookings_count || 0}</td>
                <td className="px-5 py-4 text-right"><ChevronRight className="w-4 h-4 text-ink-muted ml-auto" strokeWidth={1.5} /></td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="px-5 py-10 text-center text-ink-muted">—</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
